import React, { useState } from 'react';
import { Typography, Box, Button } from '@mui/material';
import { useTheme } from '@mui/system';

interface ReadMoreTextProps {
  text: string;
}

const ReadMoreText: React.FC<ReadMoreTextProps> = ({ text }) => {
  const words = (text || '').split(' ');
  const [isExpanded, setIsExpanded] = useState(false);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  // Always render the full text for search engines
  const fullText = (
    <Typography
      variant="body1"
      sx={{
        margin: '20px 0 10px 0',
        fontSize: '15px',
        '@media (max-width: 540px)': {
          fontSize: '14px'
        }
      }}
      gutterBottom
    >
      {text}
    </Typography>
  );

  // Render the shortened text for users
  const shortenedText = words.slice(0, 50).join(' ');

  return (
    <>
      {/* Full text for search engines (hidden visually but present in the DOM) */}
      <Box
        component="div"
        sx={{
          position: 'absolute',
          height: '1px',
          width: '1px',
          overflow: 'hidden',
          clip: 'rect(1px, 1px, 1px, 1px)',
          whiteSpace: 'nowrap'
        }}
        aria-hidden="true"
      >
        {fullText}
      </Box>

      {/* Visible content for users */}
      {isExpanded ? (
        fullText
      ) : (
        <Typography
          variant="body1"
          gutterBottom
          sx={{
            margin: '20px 0 10px 0',
            fontSize: '15px',
            '@media (max-width: 540px)': {
              fontSize: '14px'
            }
          }}
        >
          {shortenedText}
          ...{' '}
          <Button
            variant="text"
            onClick={() => setIsExpanded(true)}
            sx={{
              padding: 0,
              fontSize: 'inherit',
              textTransform: 'none',
              color: isDarkMode ? 'white' : 'primary.main',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'transparent',
                textDecoration: 'underline'
              }
            }}
          >
            Read More
          </Button>
        </Typography>
      )}
    </>
  );
};

export default ReadMoreText;
